import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function BellFull(props) {
    return (
        <SvgIcon {...props}>
            <path d={
                'M28.2657 24.3L25.9657 21.6V13C25.9657 8.3 22.6657 4.2 18.1657 3.3V3C18.1657 1.9 17.2657 1 16.1657 1C15.0657 ' +
                    '1 14.1657 1.9 14.1657 3V3.3C9.66569 4.2 6.36569 8.2 6.36569 13V21.6L4.16569 24.3C3.96569 24.5 3.96569 24.8 4.06569 ' +
                    '25.1C4.16569 25.4 4.46569 25.5 4.66569 25.5H27.6657C27.9657 25.5 28.1657 25.3 28.2657 25.1C28.3657 24.8 28.3657 24.5 ' +
                    '28.2657 24.3ZM21.4657 26.2V26.4C21.4657 27.5 20.8657 28.4 19.8657 29.1C18.8657 29.8 17.5657 30.2 16.1657 30.2C14.7657 ' +
                    '30.2 13.4657 29.8 12.4657 29.1C11.4657 28.4 10.8657 27.4 10.8657 26.4V26.2H12.7657H19.5657H21.4657Z'
            }
            />
        </SvgIcon>
    );
}

BellFull.defaultProps = {
    viewBox: '0 0 32 32'
};

export default BellFull;
